import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-503fb2ed")

_pushScopeId("data-v-503fb2ed")
const _hoisted_1 = { class: "intro_Background" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "intro__title uk-width-2-3" }, " Turn Good Ideas into Fun Visuals. ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_AlternateButton = _resolveComponent("AlternateButton")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_AlternateButton, {
      text: "Here’s a taste of how it works",
      fontSize: "16px",
      lineHeight: "24px",
      style: 4,
      actionOnClick: _ctx.finish
    }, null, 8, ["actionOnClick"])
  ]))
})